//-- Copyright (c) 2021 TMT Insights Group, LLC
import { JobDetail } from '@/redux/slices/slice_types';
import { JobDetails, TitleBar } from '@tmt-insights/oms_fe_core';

const jobDetails: JobDetails = {
  titleBar: (): TitleBar[] => [
    {
      key: 'version__external_id',
      label: 'Version External ID',
      render: (data: JobDetail) => data.version?.external_id
    }
  ],
  ignoreBulkActions: ['update'],
  skipMetadataNormalization: true
};

export default jobDetails;
